'use client'

import Link from 'next/link'
import { Anchor, Button } from '@mantine/core'
import type { AnchorProps, ButtonProps } from '@mantine/core'
import type { LinkProps } from 'next/link'
import type { ComponentPropsWithoutRef } from 'react'

// Both wrappers render `component={Link}`, which produces an anchor element, so the raw HTML
// prop base is the same. Each strips the keys owned by its own Mantine component to avoid
// collisions between the Mantine props and the HTML attributes of the same name.
type HTMLAnchorProps = ComponentPropsWithoutRef<'a'>
type ButtonHTMLProps = Omit<HTMLAnchorProps, keyof ButtonProps | 'color'>
type AnchorHTMLProps = Omit<HTMLAnchorProps, keyof AnchorProps | 'color'>
// These components render `component={Link}`, so they also accept next/link's navigation props.
type LinkNavProps = Pick<LinkProps, 'prefetch' | 'replace' | 'scroll'>

export function LinkButton(props: ButtonProps & ButtonHTMLProps & LinkNavProps & { href: string }) {
  return <Button component={Link} {...props} />
}

export function LinkAnchor(props: AnchorProps & AnchorHTMLProps & LinkNavProps & { href: string }) {
  return <Anchor component={Link} {...props} />
}
